// WhitelabelAccent — a MIXIN for a design-system primary button on the auth
// cards (signup / reset-password forms, accept-invite). On a white-label host
// it wears the tenant accent exactly like the branded sign-in's own button
// (WhitelabelSignin.js), so login, signup, reset and accept-invite read as
// one family (Nika 2026-10-14: "update login screen make it more beautiful
// for astio login").
//
//   CheckButton: { extends: ['WhitelabelAccent', 'CheckButton'], … }
//
// Off a branded host it is inert: `color` / `background` answer undefined and
// the `.isBranded` block never applies — the button keeps its `primary` theme
// pixel for pixel.
//
// The accent is a RECORD value with no design-system token to name, so it
// arrives through a reactive prop (applied inline, see below). Hover / active
// step the fill itself (brightness), never the label's opacity (Rule 65).
//
// Self-contained (FA204): no module-scope helper and no import; the colour
// maths is reached through the function registry
// (functions/whitelabelAuthPaint.js).
export const WhitelabelAccent = {
  subscribeTo: ['whitelabelBrand'],
  isBranded: (el, s) => !!(s && s.root && s.root.whitelabelBrand),
  // Reactive props apply INLINE in this build (measured on the dev shell,
  // 2026-10-14), which is what lets the accent beat the theme's
  // `[data-theme]` rules and its hover fill. `undefined` off a branded host:
  // nothing is written and the `primary` theme paints as before.
  color: (el, s) => {
    const paint = el.call('whitelabelAuthPaint', s)
    return paint ? paint.ink : undefined
  },
  background: (el, s) => {
    const paint = el.call('whitelabelAuthPaint', s)
    return paint ? paint.fill : undefined
  },
  '.isBranded': {
    width: '100%',
    round: 'radiusControl',
    ':hover': { filter: 'brightness(1.08)' },
    ':active': { filter: 'brightness(0.92)' }
  }
}
